import PortalManager from './portal_manager.js';
import {getBtnTheme} from "./helper/helpers";
const noFilterFound = gettext("%s not found");
const noResultsText = gettext("No results found");

const FormFilter = (props) => {
    const selectAllText = gettext("Select All");
    const clearFiltersText = gettext("Clear filters");
    const [parseData, setParseData] = React.useState([]);
    const [checkState, setCheckState] = React.useState(new Array(parseData.length).fill(false));
    const [checkAll, setCheckAll] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [filterTags, setFilterTags] = React.useState(0);
    const [searchFilter, setSearchFilter] = React.useState("");
    const ref = React.useRef(null);
    const refButton = React.useRef(null);
    const refList = React.useRef(null);
    const refFilterBox = React.useRef(null);
    const noFilterText = interpolate(noFilterFound, [searchFilter]);

    React.useEffect(() => {
        const checkIfClickedOutside = ({target, type}) => {
            // Should close dropdown if another element is clicked
            if(type === 'resize'){
                setIsOpen(false);
            } else {

            }
            // Should close dropdown if browser is resized
            if (refFilterBox.current && !refFilterBox.current.contains(target) && refButton.current && !refButton.current.contains(target)) {
                setIsOpen(false);
            }

        }
        document.addEventListener("mousedown", checkIfClickedOutside);
        window.addEventListener("resize", checkIfClickedOutside);
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
            window.removeEventListener("resize", checkIfClickedOutside);
        }
    }, []);

    React.useEffect(() => {
        if(!isOpen){
            setParseData(props.data);
        }
    }, [isOpen])

    React.useEffect(() => {
        setParseData(props.data);
        setCheckState(new Array(props.data.length).fill(false));
        if(props.data.length === 0){
            setCheckAll(false)
        }
    }, [props.data])

    React.useEffect(() => {
        if(parseData.length > 0){
            let parsedFilterData;
            let parsedData;
            if(props.name === 'continents'){
                parsedFilterData = parseData.filter((data) => data.checkState && data.key !== "South East Europe" && data.key !== "Southern Indian Ocean");
                parsedData = props.data.filter((data) => data.key !== "South East Europe" && data.key !== "Southern Indian Ocean");
            } else {
                parsedFilterData = parseData.filter((data) => data.checkState);
                parsedData = props.data;
            }
            if(parsedFilterData.length === parsedData.length){
                setCheckAll(true);
            } else {
                setCheckAll(false);
            }
        }
    }, [parseData])

    function showFilter(){
        setIsOpen(!isOpen);
    }

    const handleOnChange = (e, filter, value, position) => {
        const updatedCheckState = checkState.map((item, index) => {
            return index === position ? !item : item
        });
        setCheckState(updatedCheckState);
        let tempFilterTags = filterTags;
        if(e.target.checked){
            tempFilterTags += 1
        } else {
            tempFilterTags -= 1
        }
        setFilterTags(tempFilterTags);
        props.onHandleFilter(e, filter, value);
    }

    const handleSelectAll = (name) => {
        let newCheckState;
        if (checkAll){
            newCheckState = new Array(checkState.length).fill(false);
        } else {
            newCheckState = new Array(checkState.length).fill(true);
        }
        setCheckState(newCheckState);
        setCheckAll(!checkAll);
        if (checkAll) {
            setFilterTags(0);
        } else {
            setFilterTags(newCheckState.length);
        }
        props.onHandleAllFilter(name, checkAll);
    }

    const handleRemoveAllFilters = (name) => {
        setCheckState(new Array(parseData.length).fill(false));
        setFilterTags(0);
        setCheckAll(false);
        props.onHandleRemoveAllFilter(name, checkAll);
    }

    const handleSearchFilter = (e) => {
        // Access input value
        const query = e.target.value.trim();
        if(query.length > 0){
            // Create copy of item list
            let updatedList = [...props.data];
            // Include all elements which includes the search query
            updatedList = updatedList.filter((item) => {
                if(item.name){
                    return item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
                }
            });
            // Trigger render with updated values
            setParseData(updatedList);
            // Set search query for reference
            setSearchFilter(query);
        } else {
            setSearchFilter("");
            setParseData(props.data);
        }

    }
    const badgeList = parseData && parseData.length > 0 ? parseData.filter((data) => {
        if(data.name && data.name !== "South East Europe" && data.name !== "Southern Indian Ocean") {
            return data.checkState;
        }
    }) : 0;
    const renderList = parseData && parseData.length > 0 ? parseData.map((data, index) => {
        if(data.name && data.name !== "South East Europe" && data.name !== "Southern Indian Ocean"){
            return <li key={index}><input onChange={(e) => handleOnChange(e, props.name, data.key, data.indexForm)}
                                          checked={data.checkState}
                                          name={`search-filter-${index}`}
                                          id={`search-filter-${index}`}
                                          type="checkbox" readOnly={true} />
                <label htmlFor={`search-filter-${index}`}>{data.name}{' '}{props.name === "scale" && "K"}</label>
                <span>{data.number}</span>
            </li>
        }
    }) : null;
    const btnStyle = getBtnTheme();
    return (
        <React.Fragment>
            <div className="filter-box-container" ref={ref}>
                <button className={`${btnStyle} filter-button clearfix`} onClick={showFilter} ref={refButton} >
                    {props.text} { " " }
                    {badgeList.length !== 0 && <span className="badge">{badgeList.length}</span>}
                    <i className={isOpen ? "bi bi-chevron-up" : "bi bi-chevron-down"}></i>
                    {/*<i className={isOpen ? "fa fa-angle-up" : "fa fa-angle-down"} aria-hidden="true"></i>*/}
                    {/*<span className="glyphicon glyphicon-menu-down" aria-hidden="true"></span>*/}
                </button>
            </div>
            <PortalManager wrapperId="react-portal-modal-container" refDOM={ref} refBtn={refButton}>
                {
                    isOpen ? <div ref={refFilterBox} className={`form-filter-box ${isOpen ? 'open-filter' : 'close-filter'}`}>
                        <div className="form-filter-content">
                            <div className="form-filter-header">
                                <p>{props.text}</p>
                                <div className="form-filter-header-opt">
                                    <input onChange={() => handleSelectAll(props.name)}
                                           name="select-all-filter"
                                           id="select-all-filter"
                                           checked={checkAll}
                                           type="checkbox" />
                                    <label htmlFor="select-all-filter">{selectAllText}</label>
                                    <div>-</div>
                                    <a onClick={() => handleRemoveAllFilters(props.name)}>{clearFiltersText}</a>
                                </div>
                            </div>
                            <div className="form-filter-options">
                                {/*<div className="form-group has-feedback has-search">*/}
                                {/*    <i className="fa fa-search form-control-feedback" aria-hidden='true'></i>*/}
                                {/*    <input className="form-control"*/}
                                {/*           onChange={handleSearchFilter}*/}
                                {/*           type="text" placeholder={"Search"}/>*/}
                                {/*</div>*/}
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="bi bi-search form-control-feedback"></i>
                                    </span>
                                    <input className="form-control"
                                           id="filter-search"
                                           onChange={handleSearchFilter}
                                           type="text" placeholder={"Search"}/>
                                </div>
                            </div>
                            <div className="form-filter-list" ref={refList}>
                                {
                                    parseData && parseData.length > 0 ?
                                        <React.Fragment>
                                            <ul>
                                                {renderList}
                                            </ul>
                                        </React.Fragment>
                                        : null
                                }
                                {parseData.length <= 0 && <p className="text-center m-3">{noResultsText}</p>}
                            </div>
                            {/*<div className="form-filter-button">*/}
                            {/*    <button>Reset filters</button>*/}
                            {/*</div>*/}
                        </div>
                    </div> : null
                }
            </PortalManager>
        </React.Fragment>
    )
}

export default FormFilter;
